<template>
  <v-card>
    <v-tabs
      v-model="tab"
      show-arrows
      background-color="blue-grey lighten-5"
    >
      <v-tab v-for="group in groups" :key="group.uid">
        {{ group.kind.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item v-for="group in groups" :key="group.uid">
        <v-card>
          <ac-data-table
            :headers="headers"
            :items="getProducts(group)"
            :item-class="row_class"
            sort-by="name"
            item-key="uid"
            fixed-header
            :footer-props="footer"
            :items-per-page="50"
            :height="winsize.height - 220 - 36"

            :search.sync="search"
            v-model="selected"

            :can-select="item => !row_readonly(item)"
            :can-delete="item => !row_readonly(item)"
            :remove-bulk="bulkRemove"
            :bulk-mode.sync="bulkMode"

            title="Configs"
          >
            <template #actions>
              <v-btn @click="row_create(group)" class="ma-2" color="primary">
                New Config
              </v-btn>
              <v-btn @click="show_preview(group)" class="ma-2" color="accent">
                Preview JSON
              </v-btn>
            </template>

            <template v-slot:item.consumable="{item}">
              <div align="center">{{ item.consumable ? "ON" : "OFF" }}</div>
            </template>
            <template v-slot:item.enabled="{item}">
              <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
            </template>
            <template v-slot:item.icon="{item}">
              <v-image-view style="width: 50px;height: 50px" :path="getImage(item)"/>
            </template>
            <template v-slot:item.price="{item}">
              <div align="center" v-if="item.payment===0">
                <v-icon v-if="item.price.length>0">mdi-currency-usd</v-icon>
                <v-label v-else>-</v-label>
              </div>
              <div align="center" v-if="item.payment===1">
                <v-icon>mdi-cart</v-icon>
              </div>
              <div align="center" v-if="item.payment===2">
                <v-icon>mdi-help-box</v-icon>
              </div>
              <div align="center" v-if="item.payment===3">
                <v-icon>mdi-advertisements</v-icon>
              </div>
            </template>
            <template v-slot:item.actions="{item}">
              <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
                mdi-eye
              </v-icon>
              <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
                mdi-pencil
              </v-icon>
              <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
                mdi-pencil
              </v-icon>
              <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
                mdi-content-copy
              </v-icon>
              <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">
                mdi-briefcase-upload
              </v-icon>
              <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
                mdi-delete
              </v-icon>
              <v-icon :disabled="item.global || item.shared" @click="row_convert(item)" class="mr-2" small color="blue">
                mdi-cloud-upload-outline
              </v-icon>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="blue-grey" dense>
                Your search for "{{ search }}" found no results.
              </v-alert>
            </template>
          </ac-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <r-product-dialog ref="product-dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {ProductGroup} from "@/modules/redactor/models/product/ProductGroup";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ProductModel} from "@/modules/redactor/models/product/ProductModel";

import RProductDialog from "@/modules/redactor/views/product/r-product-dialog";
import VImageView from "@/views/com/ImageView.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";


export default {
  name: "r-product-page",
  components: {RDialogPreviewCollection, AcDataTable, VImageView, RProductDialog},
  data: () => ({
    tab: null,
    search: "",
    headers: [
      {text: "ID", value: "id"},
      {text: "Icon", value: "icon", sortable: false},
      {text: "Name", value: "name"},
      {text: "Place", value: "place.string"},
      {text: "Marker", value: "marker"},
      {text: "Priority", value: "priority"},
      {text: "Freeuse", value: "freeuse"},
      {text: "Quantity", value: "quantity"},
      {text: "ResetTime", value: "resettime"},
      {text: "Percent (%)", value: "percent"},
      {text: "Discount (%)", value: "discount"},
      {text: "Consumable", value: "consumable"},
      {text: "Display", value: "display"},
      {text: "Price", value: "price"},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    groups: {
      type: VueTypes.arrayOf(ProductGroup)
    },
    products: {
      type: VueTypes.arrayOf(ProductModel)
    },
    footer: {
      "items-per-page-options": [10, 50, 100, -1]
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['product-dialog'].show(ViewRules.READONLY, item.copy()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs['product-dialog'].show(ViewRules.COPY, item.copy()).then(
        data => {
          if (this.row_duplicate(data)) {
            this.$alert("Duplicate found!");
          } else {
            RedactorUtils.pushProduct(data).then(
              () => {
                this.$alert("Changes was published");
              });
          }
        }).catch(() => {
      });
    },
    row_create(group) {
      this.$refs['product-dialog'].show(ViewRules.CREATE, new ProductModel(group.kind)).then(
        data => {
          if (this.row_duplicate(data)) {
            this.$alert("Duplicate found!");
          } else {
            RedactorUtils.pushProduct(data).then(
              () => {
                this.$alert("Changes was published");
              });
          }
        }).catch((e) => {
          console.error(e);
      });
    },
    row_update(item) {
      this.$refs['product-dialog'].show(ViewRules.UPDATE, item.clone()).then(
        data => {
          if (this.row_duplicate(data)) {
            this.$alert("Duplicate found!");
          } else {
            RedactorUtils.pushProduct(data).then(
              () => {
                this.$alert("Changes was published");
              });
          }
        }).catch((e) => {
          console.error(e);
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeProduct(item).then(
          () => {
            this.$alert("Changes was published");
          });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkProducts(items);
    },

    row_convert(item) {
      this.$confirm("Are you sure you want to move this item to global config?")
        .then(() => {
          RedactorUtils.convertProduct(item.clone())
            .then(() => {
              this.$alert("Changes was published", "Convert To Global", "success");
            })
            .catch((error) => {
              this.$alert(error, "Convert To Global", "error");
            });
        });
    },
    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushProduct(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    row_duplicate(item) {
      return this.products.find(v => {
        return v.id === item.id && v.uid !== item.uid;
      });
    },

    getImage(item) {
      if (item && item.key) {
        return 'assets/products/' + item.key + '.png'
      } else {
        return "";
      }
    },
    getProducts(group) {
      return this.products.filter((value) => {
        return group.kind.equal(value.group);
      });
    },
    show_preview(group) {
      this.$refs['previewCollection'].show(this.getProducts(group), ProductModel, "product-item")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.groups = RedactorUtils.getProductGroups();
    this.products = RedactorUtils.getProducts();
  }
};
</script>
